"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 The `theme` object defined in this module serves as a central place to store global design constants.
 Always use our theme instead of Material UI's theme which is derived
 from our theme and should only be used by MUI internally.
 As always, constants that are only used by a single component should be stored in that component.
 */
var borders_1 = __importDefault(require("./config/borders"));
var breakpoints_1 = __importDefault(require("./config/breakpoints"));
var colors_1 = __importDefault(require("./config/colors"));
var dimensions_1 = __importDefault(require("./config/dimensions"));
var divider_1 = __importDefault(require("./config/divider"));
var layout_1 = __importDefault(require("./config/layout"));
var popover_1 = __importDefault(require("./config/popover"));
var shadows_1 = __importDefault(require("./config/shadows"));
var spacing_1 = __importDefault(require("./config/spacing"));
var transitions_1 = __importDefault(require("./config/transitions"));
var typography_1 = __importDefault(require("./config/typography"));
var zIndex_1 = __importDefault(require("./config/zIndex"));
var theme = {
    // zIndex
    zIndex: __assign({}, zIndex_1.default),
    // Breakpoints
    breakpoints: __assign({}, breakpoints_1.default),
    // Typography
    fontFamily: typography_1.default.fontFamily,
    bodyFontLineHeight: typography_1.default.bodyFontLineHeight,
    fonts: __assign({}, typography_1.default.fonts),
    unusedFont: typography_1.default.unusedFont,
    // Colors
    colors: __assign({}, colors_1.default.colors),
    textColors: __assign({}, colors_1.default.textColors),
    chartColors: __assign({}, colors_1.default.chartColors),
    // Shadows
    shadows: __assign({}, shadows_1.default),
    // Transitions
    transitions: __assign({}, transitions_1.default),
    // Spacings
    globalPadding: spacing_1.default.globalPadding,
    innerContentSideSpacing: spacing_1.default.innerContentSideSpacing,
    spaceBetweenGridColumns: spacing_1.default.spaceBetweenGridColumns,
    sideMargins: spacing_1.default.sideMargins,
    sideMarginsSkipOneCol: spacing_1.default.sideMarginsSkipOneCol,
    scrollBarPadding: spacing_1.default.scrollBarPadding,
    topbarHeight: spacing_1.default.topbarHeight,
    spaceBelowTopbar: spacing_1.default.spaceBelowTopbar,
    contentTop: spacing_1.default.contentTop,
    subSectionBottomMargin: spacing_1.default.subSectionPadding,
    mainContentBottomSpacing: spacing_1.default.mainContentBottomSpacing,
    dialogsBottomSpacing: spacing_1.default.dialogsBottomSpacing,
    formSectionDefaultMargin: spacing_1.default.formSectionDefaultMargin,
    // Layout
    menuItemHeight: layout_1.default.menuItemHeight,
    sidebarWidth: layout_1.default.sidebarWidth,
    sidebarWidthCollapsed: layout_1.default.sidebarWidthCollapsed,
    // Borders
    borders: __assign({}, borders_1.default),
    // Dividers
    divider: divider_1.default,
    // Popovers
    popoverTransitionDuration: popover_1.default,
    // Dimensions
    dimensions: __assign({}, dimensions_1.default),
};
exports.default = theme;
